import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./Contact.css"
import NavBar from "../NavBar/NavBar"

const Contact = () => {
    return (
        <div className='kiga-contact-page'>
          <NavBar/>
           <div className="kiga-contact-form-title">
              <p>Contact us</p>
           </div>
           <div className='kiga-contact-form-big-title'> 
              <p>We are always ready to help!</p>
           </div>
        <div className='kiga-contact-form-border'>
               
          <div className='kiga-contact-form-number'>
             <div className='kiga-contact-form-number-big-title'>
               <p>Kigali International Gymnastics Academy</p>
             </div>
             <div className='kiga-contact-form-address'>
             <i class="fa-solid fa-location-dot"></i>
                <p>22KG, 13 Avenue. Nyarutarama), Kigali,Rwanda</p>
             </div>
             <div className='kiga-contact-form-icons-contact'>
             <div className='kiga-small-navbar-email'>
               <i class="fa-regular fa-envelope"></i>
               <p>kigaliinternationalgymnasticsa@gmail.com </p>
             </div>
             <div className='kiga-small-navbar-contact'>
               <i class="fa-solid fa-phone"></i>
               <div>
                 <p>+0794970163</p>
                 <p>+0794970163</p>
               </div>
             </div>
             <div className='kiga-small-navbar-time'>
             <i class="fa-regular fa-clock"></i>
              <p>9:00Am - 8:00Pm</p>
             </div>
             </div>
          </div>
          <div className='kiga-contact-form-text'>
            <div className='kiga-contact-form-small-text'>
              <p>Send us a text message</p>
            </div>
            <form>
               <div className="form-kiga-flex-name"> 
                 <div className="form-kiga-flex-name-first">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='firstname'>FirstName<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-input-flex'>
                       <input type='text' placeHolder=" firstName"/>
                     </div>
                 </div>
                 <div className="form-kiga-flex-name-last">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='lastname'>lastName<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-input-flex'>
                       <input type='text' placeHolder=" lastName"/>
                     </div>
                 </div>
               </div>
               <div className='form-kiga-flex-radio'>
               <label className="container">Personal
                <input type="radio" checked="checked" name="radio"/>
                <span className="checkmark"></span>
              </label>
              <label className="container">Organization
                <input type="radio" name="radio"/>
                <span className="checkmark"></span>
              </label>
               </div>
               <div className="form-kiga-flex-email">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='email'>Email<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-input'>
                       <input type='email' placeHolder=" Email"/>
                     </div>
                 </div>
                 <div className="form-kiga-flex-country">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='country'>Country<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-input'>
                       <input type='text' placeHolder=" Country"/>
                     </div>
                 </div>
                 <div className="form-kiga-flex-phone">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='phone'>Phone Number<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-input'>
                       <input type='number' placeHolder=" Phone Number"/>
                     </div>
                 </div>
                 <div className="form-kiga-flex-message">
                     <div className='form-kiga-flex-label'>
                       <label htmlFor='message'>Message<span>*</span></label>
                     </div>
                     <div className='form-kiga-flex-message-input'>
                       <input type='text' placeHolder=" Message"/>
                     </div>
                 </div>
                 <div className="form-kiga-flex-checkmark-receive">
                     <label class="container">I would like to receive logistics related news and marketing updates via e-mail or phone.
                        <input type="checkbox"/>
                        <span class="checkmark"></span>
                     </label>
                 </div>
                 <div className='form-kiga-flex-button'>
                     <button type='submit'>Send</button>
                 </div>
            </form>
          </div>
        </div>
        </div>
      )
}

export default Contact
